//Keep this in sync with //depot/devmain/msoserviceplatform/src/Browser/App/Packages/AppsForOffice/script/SingleSignOnInfo.cs

enum OmexMessageType {
    ConsentResult = 0,
    TabExit = 1,
    ButtonClick = 2,
    PageLoad = 3,
}

export default OmexMessageType;
